// Function to create draft order
async function createDraftOrder(formData) {
  try {
    const response = await fetch('/admin/api/2024-01/draft_orders.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Access-Token': window.shopifyAccessToken
      },
      body: JSON.stringify({
        draft_order: {
          line_items: [
            {
              title: formData.ignitionType,
              quantity: 1,
              price: formData.price || 0.00
            }
          ],
          customer: {
            first_name: formData.firstName,
            last_name: formData.lastName,
            email: formData.email,
            phone: formData.phone
          },
          note: `Appointment Details:
            Date: ${formData.appointmentDate}
            Location: ${formData.shopLocation}
            Vehicle: ${formData.carMake} ${formData.carModel}
            Registration: ${formData.rego}`
        }
      })
    });

    if (!response.ok) {
      throw new Error('Failed to create draft order');
    }

    return await response.json();
  } catch (error) {
    console.error('Error creating draft order:', error);
    throw error;
  }
}

// Export the function
window.createDraftOrder = createDraftOrder; 